const activeEnv = process.env.STAGE_ENV || 'development';

require('dotenv').config({
  path: `.env.${activeEnv}`,
});
// import "./styles/styles.scss";
export * from './components/widgets';
export * from './components/hooks';
export * from './transforms';
export * from './utils';
